<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
    <div class="widget__wrap">
        <div class="widget" id="pages-widget">
            <h2 class="widget__header">
                <span class="widget__header__title">
                    <i class="widget__header__icon ico-angle-down"></i> Stránky</span>
                <span class="widget__header__tools">
                    <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
                    <a [routerLink]="['add']" class="cta cta--small cta--green">
                        <span class="cta__light">Přidat</span> stránku
                        <i class="ico-plus"></i>
                    </a>
                </span>
            </h2>
            <div class="widget__content">
                <swb-pages-list [query]="query"></swb-pages-list>
            </div>
        </div>
    </div>
    <swb-page-designboxes></swb-page-designboxes>
    <swb-page-storyboards></swb-page-storyboards>
</div>
<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
    <swb-page-tiles></swb-page-tiles>
    <swb-page-contentboxes></swb-page-contentboxes>
</div>
<router-outlet></router-outlet>